import { SectionProps } from '../authSections/types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { Link as LinkIcon, Key, Lock } from 'lucide-react'

export default function MicrosoftGraphOAuthSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="url"
          label="Token URL"
          icon={<LinkIcon size={16} />}
          value={watch('oauth.token_url') || ''}
          onChange={(value) => setValue('oauth.token_url', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Tenant ID"
          value={watch('oauth.tenant_id') || 'common'}
          onChange={(value) => {
            setValue('oauth.tenant_id', value);
            // Auto-update token URL when tenant_id changes
            const tenantId = value || 'common';
            const tokenUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`;
            setValue('oauth.token_url', tokenUrl);
          }}
          className={styles.input}
        />
        <p className={styles.helpText}>
          Use 'common' for multi-tenant apps, or specify your tenant ID. Token URL will be updated automatically.
        </p>
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="key"
          label="Client ID"
          icon={<Key size={16} />}
          value={watch('oauth.client_id') || ''}
          onChange={(value) => setValue('oauth.client_id', value)}
          autoComplete="new-client-id"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="Client Secret"
          icon={<Lock size={16} />}
          value={watch('oauth.client_secret') || ''}
          onChange={(value) => setValue('oauth.client_secret', value)}
          autoComplete="new-password"
          skipPasswordValidation={true}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Scope"
          value={watch('oauth.scope') || ''}
          onChange={(value) => setValue('oauth.scope', value)}
          className={styles.input}
        />
      </div>
    </>
  )
}
